import { FilterGroup } from '../Tools/FilterGroup';
import { BathroomTypeFilter } from '../Filters/BathroomTypeFilter';
import { ObjectTypeFilter } from '../Filters/ObjectTypeFilter';
import { GenericElement } from '../Elements/GenericElement';
import { FiltersWidget } from '../FiltersWidget';
import { FiltersController } from '../Tools/FiltersController';
import { IFilter } from '../Tools/IFilter';
import { Events, eventsManager } from '@rhinov/savane-js';
import { _ASSET_TYPE, getAssets, getHandles } from '@rhinov/asset-manager-service';

export class BathRoomFilterWidget extends FilterGroup {
    constructor(container: string, bathroomElements: GenericElement[]) {
        super();
        this.id = 'bathroom';
        this.name = 'Salle de bain';
        this.icon = 'fas fa-lg fa-bath';
        this.resource = 'assets';
        this.filtersFunction = 'updateFilters';
        this.filters = [
            new BathroomTypeFilter(bathroomElements, this),
            new ObjectTypeFilter(this)
        ]
        this.container = container;
        this.controller = new FiltersController();
    }

    static getInstance(): BathRoomFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'bathroom') as BathRoomFilterWidget || null;
    }

    generateStringFilter() {
        let stringFilters = '&q.pipeline.modelState.eq=validated&q.pipeline.state.in=available,archived&q.pipeline.unrealState.eq=ready';

        this.filters.forEach((filter: IFilter) => {
            stringFilters += filter.generateStringFilter();
        });

        return stringFilters;
    };

    update(): void {
        this.destroy();
        this.html();
    }

    selectionListener?: () => void;

    html(): void {
        this.isDestroyed = false;
        this.loadAllAssets().then(() => {
            this.selectionListener = () => { this.updateAllActiveLists(); };
            FilterGroup.addEntitySelectionListener(this.selectionListener);
            let html = this.filtersHtml() + `
            <div>
                <h style="font-weight:600;">Personnalisation Lapeyre Forméo</h>
                <div class="padding">
                    <div style="display:contents" id="Caisson-parent">
                        ${this.CaissonHtml()}
                    </div>
                    <div style="display:contents" id="Chant-parent">
                        ${this.ChantHtml()}
                    </div>
                    <div style="display:contents" id="Poignee-parent">
                        ${this.PoigneeHtml()}
                    </div>
                </div>
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
            eventsManager.instance.dispatch(Events.CAMERA_RESIZED);
        });
    }

    loadAllAssets(): Promise<void[]> {
        let doorPromise = this.getAllDoor();
        let MirrorPromise = this.getAllMirror();
        let handlePromise = this.getAllHandleModels();
        return Promise.all([doorPromise, MirrorPromise, handlePromise]);
    }

    getAllDoor(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreFormeoCabinetCoatings.length !== 0) {
                resolve();
                return;
            }
            getAssets(_ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_FORMEO_COLORIS&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res: any) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreFormeoCabinetCoatings = resources;
                    resolve();
                } else {
                    reject('No resources found for Lapeyre Formeo cabinet coatings');
                }
            });
        });
        return promise;
    }

    getAllMirror(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreFormeoMirrorCoatings.length !== 0) {
                resolve();
                return;
            }
            getAssets(_ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_FORMEO_COLORIS,CG_LAPEYRE_FORMEO_COLORIS_MIROIRS&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res: any) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreFormeoMirrorCoatings = resources;
                    resolve();
                } else {
                    reject('No resources found for Lapeyre Formeo mirror coatings');
                }
            });
        });
        return promise;
    }

    getAllHandleModels(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreFormeoHandleModels.length !== 0) {
                resolve();
                return;
            }
            getHandles(FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&sort=name&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.manufacturer.eq=5eba5c37f3c97d07e6f83b5e', '6793a50125716ef37a5cc007,5f6b6699e9de7056bb9155d1', function (res: any) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreFormeoHandleModels = resources;
                    resolve();
                } else {
                    reject('No resources found for Lapeyre Formeo handle models');
                }
            });
        });
        return promise;
    }

    updateActive(objects: any[], customName: string, isHandle?: boolean) {
        objects.forEach((object) => {
            FilterGroup.cache.name = "";
            let isActive: boolean = false;
            if (isHandle) isActive = FilterGroup.isHandleUsed(object, FiltersWidget.ArrangementType.bathroomCustomizableArrangements) ?? false;
            else isActive = FilterGroup.isCoatingUsed(object, customName, FiltersWidget.ArrangementType.bathroomCustomizableArrangements) ?? false;

            let display = isActive ? "" : "none";
            $(`#active-${object.name}-${customName}`).css('display', display);
        })
    }

    updateAllActiveLists() {
        this.updateActive(FilterGroup.allLapeyreFormeoCabinetCoatings, 'Caisson');
        this.updateActive(FilterGroup.allLapeyreFormeoMirrorCoatings, 'Chant');
        this.updateActive(FilterGroup.allLapeyreFormeoHandleModels, "Poignee", true);
    }

    getGenericHtml(coatings: any[], customName: string, getPreviewUrl: (coating: any) => string, title: string): string {
        let coatingsHtml = coatings.map((coating: any) => {
            setTimeout(() => {
                let listener = () => {
                    FilterGroup.updateArrangementCoating(coating, customName, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
                    this.updateActive(coatings, customName);
                }

                this.controller.addEventListener('click', listener, `div-${coating.name}-${customName}`);
                this.controller.addEventListener('click', listener, `img-${coating.name}-${customName}`);
            });

            const isUsed = FilterGroup.isCoatingUsed(coating, customName, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);

            return `
                <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;"
                        title="${coating.name}" id="div-${coating.name}-${customName}">
                    </div>
                    <img style="width:50px;height:50px;" id="img-${coating.name}-${customName}" 
                        src="${getPreviewUrl(coating)}">
                    <div id="active-${coating.name}-${customName}" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                        <i class="fa-solid fa-check"></i>
                    </div>
                </div>
                `;
        }).join('');

        return `
        <div style="text-align: left;">${title}</div>
        <div
            style="margin-bottom:10px;padding:0;width: 100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
            ${coatingsHtml}
        </div>
        `;
    }

    CaissonHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreFormeoCabinetCoatings,
            'Caisson',
            (coating: any) => FilterGroup.getCabinetCoatingPreviewUrl(coating) || '',
            'Caissons/Portes'
        );
    }

    ChantHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreFormeoMirrorCoatings,
            'Chant',
            (coating: any) => FilterGroup.getCabinetCoatingPreviewUrl(coating) || '',
            'Bords de miroir'
        );
    }

    PoigneeHtml(): string {
        let handlesHtml = FilterGroup.allLapeyreFormeoHandleModels.map((modele: any) => {
            setTimeout(() => {
                let listener = () => {
                    FilterGroup.updateArrangementHandleModeleType(modele, FiltersWidget.ArrangementType.bathroomCustomizableArrangements).then(() => {
                        this.updateActive(FilterGroup.allLapeyreFormeoHandleModels, "Poignee", true);
                    });
                }
                this.controller.addEventListener('click', listener, `div-${modele.name}-Poignee`);
                this.controller.addEventListener('click', listener, `img-${modele.name}-Poignee`);
            });

            let isUsed = FilterGroup.isHandleUsed(modele, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
            return `
            <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                <div id="div-${modele.name}-Poignee"
                style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;" title="${modele.name}">
                </div>
                <img id="img-${modele.name}-Poignee" style="width:50px;height:50px;" src="${FilterGroup.getHandlePreviewUrl(modele)}">
                <div id="active-${modele.name}-Poignee" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                    <i class="fa-solid fa-check"></i>
                </div>
            </div>
        `;
        }).join('');

        setTimeout(() => {
            let listener = () => {
                FilterGroup.removeArrangementHandleModel(FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
                this.updateActive(FilterGroup.allLapeyreFormeoHandleModels, "Poignee", true);
            }
            this.controller.addEventListener('click', listener, 'NoHandle');
        });

        return `
        <div style="text-align: left;">Poignées</div>
        <div style="margin-bottom:10px;padding:0;width:100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
            ${handlesHtml}
            <div id="NoHandle" title="Pas de poignée" style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                <i class="far fa-2x fa-trash-alt" style="vertical-align: middle;"></i>
            </div>
        </div>
        `;
    }

    destroy(): void {
        super.destroy();
        if (this.selectionListener) {
            FilterGroup.removeEntitySelectionListener(this.selectionListener);
        }
        this.selectionListener = undefined;
    }
}